export default {"src":"/_next/static/media/close-popup.46365f09.svg","height":20,"width":20};